window.PEPTIDLAB_CONFIG = {
  brand: "PeptidLab by Yana",
  contacts: {
    telegram: "https://t.me/yana_dia7",
    whatsapp: "https://wa.me/380974266040",
    instagram: "https://www.instagram.com/cosmetologist.yana_?stkn=MWt5aHkxczRpbzJsNA==",
    tiktok: "https://www.tiktok.com/@yanadiaz86?_r=1",
    email: "yana86diadchuk@gmail.com",
  },
};
